import React, { useEffect, useState } from 'react';
import { Button } from "devextreme-react";
import TreeView from 'devextreme-react/tree-view';
import CustomStore from "devextreme/data/custom_store";
import * as Utils from "../../../utils/Utils";
import Request from "../../../components/api/Request";
import DropDownBox from 'devextreme-react/drop-down-box';
import { DataGrid, Column, ColumnChooser, FilterRow, Pager, Paging, Selection } from "devextreme-react/data-grid";
import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box';


const SeleniumRemote = (props) => {

    const [formYetki, setFormYetki] = useState(
        {
            seleniumSessionList: Utils.hasRole("tanimlar|roleTanim|seleniumSessionList"),
            seleniumSil: Utils.hasRole("tanimlar|roleTanim|seleniumSil"),
            goruntule: Utils.hasRole("tanimlar|roleTanim|goruntule"),
            listele: Utils.hasRole("tanimlar|roleTanim|listele"),
            ekle: Utils.hasRole("tanimlar|roleTanim|ekle"),
            degistir: Utils.hasRole("tanimlar|roleTanim|degistir"),
            sil: Utils.hasRole("tanimlar|roleTanim|sil"),
        });

    const listeBasligi = "Remote Selenium Session Listesi";
    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }
    const [store, setStore] = useState(null);
    const [aktifSession, setAktifSession] = useState([]);

    let dataGrid = null;
    let treeView = null;

    useEffect(() => {
        domainListYukle();
        setStore(getStore());
    }, [])

    useEffect(() => {
        if (aktifSession.length > 0) {
            let tempGrid = dataGrid;
            debugger;
        }
    }, [aktifSession])


    const domainListYukle = () => {
        const request = new Request("/userDomain/getUserDomainList", "GET");
        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }

    const aktifSessionlariGetir = () => {
        console.log("yüklendikten sonra");
        const request = new Request("/seleniumRemoteWeb/getAktifSessionList", "GET");

        return request.run()
            .then(response => {
                if (response.data) {
                    if (response.data.status === 0) {
                        return response.data.value
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            }).catch(() => {
                return [];
            });
    }


    const yenile = () => {
        setStore(getStore());
    }

    const getStore = () => {
        let tempGrid = dataGrid;

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                let params = '?';
                ['skip', 'take', 'requireTotalCount', 'requireGroupCount',
                    'sort', 'totalSummary', 'group', 'groupSummary'].forEach(function (i) {
                        if (i in loadOptions && Utils.isNotEmpty(loadOptions[i])) {
                            params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                        }
                    });

                let filterArr = [];
                if (loadOptions['filter'] && Utils.isNotEmpty(loadOptions['filter'])) {
                    let gridColumns = tempGrid.props.children.filter(function (x) {
                        if (x.type.name === "Column")
                            return x
                    })
                    filterArr = Utils.filterNormalize(loadOptions['filter'], gridColumns);
                }

                if (treeBoxValue.length > 0) {
                    filterArr.push({
                        property: "domain.id",
                        operator: "IN",
                        value: treeBoxValue,
                        type: "Long"
                    })
                }

                if (filterArr.length > 0) {
                    params += "filter=" + JSON.stringify(filterArr);
                } else {
                    params = params.slice(0, -1);
                }

                const request = new Request("/seleniumRemoteWeb/getKayitList" + params, "GET");

                return request.run()
                    .then(async (response) => {
                        if (response.data) {
                            let aktifSessions = await aktifSessionlariGetir();
                            let data = [];
                            if (response.data.data.length > 0) {
                                response.data.data.map(x => {
                                    let temp = x;
                                    x["seleniumAktif"] = aktifSessions.filter(a => a.id === x.sessionId).length > 0;
                                    data.push(x);
                                })
                            }

                            if (aktifSessions.length > 0) {
                                let sira = 1;
                                aktifSessions.map(x => {
                                    if (response.data.data.filter(b => b.sessionId == x.id).length == 0){
                                        // data.push(
                                        //     {
                                        //         "domain": { "name": "ARI-IK KAYITLARINDA YOK", "id": -1 },
                                        //         "name": "-----",
                                        //         "sessionId": x.id,
                                        //         "id": sira * -1,
                                        //         "aktif": false,
                                        //         "seleniumAktif": false
                                        //     }
                                        // );
                                    }
                                     
                                    // response.data.total++;
                                    sira++;
                                })
                            }

                            return {
                                data: data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }


    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
            />
        );
    }

    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    function sil(data) {

        if (data.id < 0) {
            silSeleniumSession(data.sessionId);
            return;
        }

        const request = new Request("/seleniumRemoteWeb/deleteKayit/" + data.id, "DELETE");
        return request.run()
            .then(response => {
                if (response.data && response.data.success) {
                    yenile();
                }
            });
    }

    function silSeleniumSession(sessionId) {
        const request = new Request("/seleniumRemoteWeb/deleteSeleniumSession/" + sessionId, "DELETE");
        return request.run()
            .then(response => {
                if (response.data && response.data.success) {
                    yenile();
                }
            });
    }

    function dateRender(data, b, c) {
        if (data.value === true) {
            return <b style={{ color: "green" }}>{data.value.toString()}</b>;
        } else {
            return <b style={{ color: "red" }}>{data.value.toString()}</b>;

        }
    }

    return <React.Fragment>
        <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
        <div id="page">
            <ResponsiveBox>
                <Row>
                    <Item>
                        <Location screen="md lg" row={0} col={0} colspan={3} />
                        <Location screen="xs sm" row={0} col={0} />
                        <div className="header item">
                            <p>Header</p>
                        </div>
                    </Item>
                </Row>
            </ResponsiveBox>
        </div>
        <div className="dx-field">
            <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                <DropDownBox
                    value={treeBoxValue}
                    valueExpr="id"
                    displayExpr="name"
                    placeholder="Firma Seçiniz..."
                    showClearButton={true}
                    dataSource={treeDataSource}
                    onValueChanged={syncTreeViewSelection}
                    contentRender={treeViewRender}
                />
                <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                    onClick={yenile}></Button>
            </div>
        </div>

        <DataGrid
            ref={ref => dataGrid = ref}
            style={{ padding: 5 }}
            width="100%"
            height="100%"
            dataSource={store}
            key={"id"}
            keyExpr="id"
            showBorders={true}
            focusedRowEnabled={true}
            allowColumnResizing={true}
            columnResizingMode={"widget"}
            //defaultFocusedRowIndex={0}
            columnAutoWidth={true}
            repaintChangesOnly={true}
            //columnHidingEnabled={true}
            //onToolbarPreparing={onToolbarPreparing}
            //selection={{mode: 'multiple', deferred:true}}
            remoteOperations={true}>

            <FilterRow visible={true} />
            <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
            <Paging defaultPageSize={1000} />
            <Pager showPageSizeSelector={true} allowedPageSizes={[1000]} showInfo={true}  visible={true} />
            <Selection mode="multiple" selectAllMode="page" showCheckBoxesMode="onClick" />
            <Column dataField={'domain.name'} width={150} caption={'Domain Adı'} dataType="string" visible={true}
                mappingField="name" />
            <Column dataField={'name'} width={90} caption={'Bağlantı Adı'} dataType="string" visible={true}
                mappingField="name" />
            <Column dataField="aktif" width={90} caption={'Aktif'} dataType="string" visible={true}
                mappingField="aktif" />
            <Column dataField={'createDate'} width={120} caption={'Oluşturma Zamanı'} dataType="string" visible={true} />
            <Column dataField={'sonCalismaZamani'} width={120} caption={'Son İşlem Zamanı'} dataType="string"
                visible={true} />
            <Column dataField={'sessionId'} width={90} caption={'Selenium Id'} dataType="string" visible={true} />
            <Column dataField={'seleniumAktif'} width={90} caption={'Selenium Aktif'} dataType="string" visible={true}
                cellRender={dateRender} />
            <Column type="buttons" caption={'İşlem'}
                buttons={[
                    {
                        hint: 'Sil', icon: 'remove',
                        visible: () => { return formYetki.seleniumSil },
                        onClick: (e) => {
                            sil(e.row.data);
                        }
                    },
                ]}
            />


        </DataGrid>

    </React.Fragment>
}

export default SeleniumRemote;
